var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"对不起，您正在寻找的页面不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }